import { merge, cloneDeep } from 'lodash'
import { create } from 'zustand'
import { State } from './types'

export default create<State>((set) => ({
  saveVehicleDataModal: false,
  saveVehicleDataCallback: null,
  update: (state: State) => {
    set((oldState) => cloneDeep(merge(oldState, state)))
  },
}))
